module.exports = __webpack_public_path__ + "static/w_neun__stehend_sw-a04da591e0dedf4d06d9bc175d95b22b.jpg";